import { PoolInfo } from "../context/types";

export const calcualteMinMachinePower = ({
  heatDemandOrLoss,
  poolInfo,
}: {
  heatDemandOrLoss: number[];
  poolInfo: PoolInfo;
}) => {
  const minMachinePower24 = heatDemandOrLoss.map((heat) =>
    heat > 0 ? heat : 0
  );

  const maxMachinePowerReal = minMachinePower24.map(
    (heat) => (heat * 24) / poolInfo.operatingHours
  );

  return { minMachinePower24, maxMachinePowerReal };
};
